<template>
  <div style="margin: 15px">
    <el-form :inline="true" label-width="170px" label-position="right" class="custom-label">
      <el-form-item label="薪资类型:">
        <el-input v-model="salary_type" placeholder="薪资类型" :disabled="true"></el-input>
      </el-form-item>
    </el-form>
    <el-form :inline="false" label-width="170px" label-position="left" class="custom-label">
      <el-form-item label="工龄奖:">
        <el-checkbox v-model="salary_work_year">有</el-checkbox>
      </el-form-item>
      <el-form-item label="描述：">
        <el-input
            v-model="description"
            style="width: 90%"
            :autosize="{ minRows: 3, maxRows: 6 }"
            maxlength="200"
            type="textarea"
        />
      </el-form-item>
      <el-form-item label="正班工时计算规则:">
      </el-form-item>
    </el-form>


    <div class="box ">
      <el-form :inline="true" label-width="170px" label-position="right">
        <el-form-item label="工作日:" required="true">
          <el-select v-model="work_day" placeholder="请选择工作日" style="width: 170px">
            <el-option label="法定工作日" value="legal_work_day"></el-option>
            <el-option label="1~31日实际出勤" value="actual_attendance"></el-option>
          </el-select>
          <div v-if="work_day === 'legal_work_day'" style="margin-left: 10px">
            <el-checkbox
                v-for="day in days"
                :key="day.id"
                v-model="day.selected"
                :label="day.name">
            </el-checkbox>
          </div>
        </el-form-item>
      </el-form>
      <el-form :inline="true" label-width="170px" label-position="right">
        <el-form-item label="节假日:" required="true">
          <el-select v-model="holiday_day" placeholder="请选择节假日" style="width: 170px">
            <el-option label="国家法定" value="country"></el-option>
            <el-option label="公司规定" value="company"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-form :inline="true" label-width="170px" label-position="right">
        <el-form-item label="有薪假:" required="true">
          <el-select v-model="paid_leave" placeholder="请选择有薪日" style="width: 170px">
            <el-option label="有" value="have"></el-option>
            <el-option label="无" value="not_have"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>

    <el-form :inline="false" label-width="170px" label-position="left" class="custom-label">
      <el-form-item label="应出勤天数计算规则：">
      </el-form-item>
    </el-form>
    <div class="box ">
      <el-form :inline="true" label-width="170px" label-position="right">
        <el-form-item label="应出勤天数:" required="true">
          <el-select v-model="attendance_day" placeholder="请选择出勤天数" style="width: 170px">
            <el-option v-for="day in attendance_day_options"
                       :key="day.value"
                       :value="day.value"
                       :label="day.label">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>

    <el-form :inline="true" label-width="170px" label-position="left" class="custom-label">
      <el-form-item label="平时加班时长计算规则:">
        <el-checkbox v-model="daily_overtime.is_daily_overtime">有</el-checkbox>
      </el-form-item>
    </el-form>

    <div class="box">
      <el-form :inline="true" label-width="170px" label-position="right" v-model="daily_overtime">
        <el-form-item label="周一 ~ 周五:" required="true">
          <el-select v-model="daily_overtime.working_day_daily_overtime_rule" placeholder="请选择规则"
                     style="width: 170px">
            <el-option label="不计算" value="no_computation"></el-option>
            <el-option label="全天" value="all_day"></el-option>
            <el-option label="正班加班时数" value="regular_overtime"></el-option>
          </el-select>
        </el-form-item>
<!--        <el-form-item label="开始时间:" required="true"
                      v-if="daily_overtime.working_day_daily_overtime_rule === 'regular_overtime'">
          <el-time-picker v-model="daily_overtime.working_day_daily_overtime_start" placeholder="请选择时间"
                          value-format="HH:mm:ss"/>
        </el-form-item>-->
      </el-form>
      <el-form :inline="true" label-width="170px" label-position="right">
        <el-form-item label="周六:" required="true" v-model="daily_overtime">
          <el-select v-model="daily_overtime.saturday_daily_overtime_rule" placeholder="请选择规则"
                     style="width: 170px">
            <el-option label="不计算" value="no_computation"></el-option>
            <el-option label="全天" value="all_day"></el-option>
            <el-option label="正班加班时数" value="regular_overtime"></el-option>
          </el-select>
        </el-form-item>
<!--        <el-form-item label="开始时间:" required="true"
                      v-if="daily_overtime.saturday_daily_overtime_rule === 'regular_overtime'">
          <el-time-picker v-model="daily_overtime.saturday_daily_overtime_start" placeholder="请选择时间"
                          value-format="HH:mm:ss"/>
        </el-form-item>-->
      </el-form>
      <el-form :inline="true" label-width="170px" label-position="right" v-model="daily_overtime">
        <el-form-item label="周日:" required="true">
          <el-select v-model="daily_overtime.sunday_daily_overtime_rule" placeholder="请选择规则"
                     style="width: 170px">
            <el-option label="不计算" value="no_computation"></el-option>
            <el-option label="全天" value="all_day"></el-option>
            <el-option label="正班加班时数" value="regular_overtime"></el-option>
          </el-select>
        </el-form-item>
<!--        <el-form-item label="开始时间:" required="true"
                      v-if="daily_overtime.sunday_daily_overtime_rule === 'regular_overtime'">
          <el-time-picker v-model="daily_overtime.sunday_daily_overtime_start" placeholder="请选择时间"
                          value-format="HH:mm:ss"/>
        </el-form-item>-->
      </el-form>
    </div>

    <el-form label-width="170px" label-position="left" class="custom-label">
      <el-form-item label="周末加班:">
        <el-checkbox v-model="weekday_overtime.is_weekend_overtime">有</el-checkbox>
      </el-form-item>
    </el-form>

    <div class="box">
      <el-form :inline="true" label-width="170px" label-position="right" v-model="weekday_overtime">
        <el-form-item label="周一 ~ 周五:" required="true">
          <el-select v-model="weekday_overtime.working_day_weekday_overtime_rule" placeholder="请选择规则"
                     style="width: 170px">
            <el-option label="不计算" value="no_computation"></el-option>
            <el-option label="全天" value="all_day"></el-option>
            <el-option label="正班加班时数" value="regular_overtime"></el-option>
          </el-select>
        </el-form-item>
<!--        <el-form-item label="开始时间:" required="true"
                      v-if="weekday_overtime.working_day_weekday_overtime_rule === 'regular_overtime'">
          <el-time-picker v-model="weekday_overtime.working_day_weekday_overtime_start" placeholder="请选择时间"
                          value-format="HH:mm:ss"/>
        </el-form-item>-->
      </el-form>
      <el-form :inline="true" label-width="170px" label-position="right" v-model="weekday_overtime">
        <el-form-item label="周六:" required="true">
          <el-select v-model="weekday_overtime.saturday_weekday_overtime_rule" placeholder="请选择规则"
                     style="width: 170px">
            <el-option label="不计算" value="no_computation"></el-option>
            <el-option label="全天" value="all_day"></el-option>
            <el-option label="正班加班时数" value="regular_overtime"></el-option>
          </el-select>
        </el-form-item>
<!--        <el-form-item label="开始时间:" required="true"
                      v-if="weekday_overtime.saturday_weekday_overtime_rule === 'regular_overtime'">
          <el-time-picker v-model="weekday_overtime.saturday_weekday_overtime_start" placeholder="请选择时间"
                          value-format="HH:mm:ss"/>
        </el-form-item>-->
      </el-form>
      <el-form :inline="true" label-width="170px" label-position="right" v-model="weekday_overtime">
        <el-form-item label="周日:" required="true">
          <el-select v-model="weekday_overtime.sunday_weekday_overtime_rule" placeholder="请选择规则"
                     style="width: 170px">
            <el-option label="不计算" value="no_computation"></el-option>
            <el-option label="全天" value="all_day"></el-option>
            <el-option label="正班加班时数" value="regular_overtime"></el-option>
          </el-select>
        </el-form-item>
<!--        <el-form-item label="开始时间:" required="true"
                      v-if="weekday_overtime.sunday_weekday_overtime_rule === 'regular_overtime'">
          <el-time-picker v-model="weekday_overtime.sunday_weekday_overtime_start" placeholder="请选择时间"
                          value-format="HH:mm:ss"/>
        </el-form-item>-->
      </el-form>
    </div>

    <el-form label-width="170px" label-position="left" class="custom-label" v-model="awards">
      <el-form-item label="在职奖:">
        <el-checkbox v-model="awards.salary_on_job">有</el-checkbox>
      </el-form-item>
      <el-form-item label="全勤:">
        <el-checkbox v-model="awards.salary_full_attendance">有</el-checkbox>
      </el-form-item>
      <el-form-item label="车补:">
        <el-checkbox v-model="awards.salary_car">有</el-checkbox>
      </el-form-item>
      <el-form-item label="房补:">
        <el-checkbox v-model="awards.salary_house">有</el-checkbox>
      </el-form-item>
      <el-form-item label="无尘服补贴:">
        <el-checkbox v-model="awards.salary_clean_cloth">有</el-checkbox>
      </el-form-item>
      <el-form-item label="无尘服补贴:" :required="true" v-if="awards.salary_clean_cloth">
        <el-cascader v-model="awards.subsidy_department" :options="departmentList"
                     :props="optionProps" placeholder="请选择"  style="width: 100%"/>
      </el-form-item>
      <el-form-item label="岗位补贴:">
        <el-checkbox v-model="awards.salary_post">有</el-checkbox>
      </el-form-item>
      <el-form-item label="绩效:">
        <el-checkbox v-model="awards.salary_performance">有</el-checkbox>
      </el-form-item>
      <el-form-item label="高温补贴:">
        <el-checkbox v-model="awards.salary_temperature">有</el-checkbox>
      </el-form-item>
    </el-form>

    <el-form label-width="170px" label-position="left" class="custom-label" v-model="deductions">
      <el-form-item label="水电费扣款:">
        <el-checkbox v-model="deductions.water_electricity_deduction">有</el-checkbox>
      </el-form-item>
      <el-form-item label="补差异:">
        <el-checkbox v-model="deductions.difference_deduction">有</el-checkbox>
      </el-form-item>
      <el-form-item label="扣款:">
        <el-checkbox v-model="deductions.deduction">有</el-checkbox>
      </el-form-item>
    </el-form>

    <div style="display: flex;justify-content: center;margin-bottom: 20px">
      <el-button type="primary" @click="saveButton">保存</el-button>
    </div>

  </div>
</template>

<script>


export default {
  name: "SalaryType",
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      optionProps: {
        value: 'id',
        label: 'name',
        multiple: true,
        checkStrictly :true,
        emitPath:false
      },
      salary_type: '',
      salary_work_year: false,
      work_day: '',
      holiday_day: '',
      description:'',
      departmentList: [],
      //工作日checkbox
      days: [
        {id: 1, name: '周一', selected: false},
        {id: 2, name: '周二', selected: false},
        {id: 3, name: '周三', selected: false},
        {id: 4, name: '周四', selected: false},
        {id: 5, name: '周五', selected: false},
        {id: 6, name: '周六', selected: false},
        {id: 7, name: '周日', selected: false}
      ],
      //带薪假
      paid_leave: '',
      //出勤天数
      attendance_day: '',
      //应出勤天数select
      attendance_day_options: [{
        value: 'double_break',
        label: '上五休二'
      }, {
        value: 'single_break',
        label: '上六休一'
      }, {
        value: 'single_break_month',
        label: '月休一天'
      }, {
        value: 'double_break_month',
        label: '月休两天'
      }],
      //平时加班计算规则
      daily_overtime: {
        is_daily_overtime: false,
        working_day_daily_overtime_rule: '',
        saturday_daily_overtime_rule: '',
        sunday_daily_overtime_rule: '',
        working_day_daily_overtime_start: '',
        saturday_daily_overtime_start: '',
        sunday_daily_overtime_start: '',
      },

      //周末加班
      weekday_overtime: {
        is_weekend_overtime: false,
        working_day_weekday_overtime_rule: '',
        saturday_weekday_overtime_rule: '',
        sunday_weekday_overtime_rule: '',
        working_day_weekday_overtime_start: '',
        saturday_weekday_overtime_start: '',
        sunday_weekday_overtime_start: '',
      },

      subsidy_department_options: [],
      awards: {
        salary_on_job: false,
        salary_full_attendance: false,
        salary_car: false,
        salary_house: false,
        salary_clean_cloth: false,
        salary_post: false,
        salary_performance: false,
        salary_temperature: false,
        subsidy_department: []
      },
      deductions: {
        water_electricity_deduction: false,
        difference_deduction: false,
        deduction: false
      }
    }
  },
  methods: {
    async saveButton() {
      if (!this.work_day || this.work_day === '') {
        this.$message({
          message: "请选择工作日",
          type: "error",
        });
        return;
      }

      if (!this.holiday_day || this.holiday_day === '') {
        this.$message({
          message: "请选择节假日",
          type: "error",
        });
        return;
      }

      if (!this.paid_leave || this.paid_leave === '') {
        this.$message({
          message: "请选择有薪水日",
          type: "error",
        });
        return;
      }

      if (!this.attendance_day || this.attendance_day === '') {
        this.$message({
          message: "请选择出勤天数",
          type: "error",
        });
        return;
      }

      if (this.daily_overtime.is_daily_overtime) {
        console.log(this.daily_overtime.saturday_daily_overtime_start)
        if (!this.daily_overtime.working_day_daily_overtime_rule || this.attendance_day === ''
            || !this.daily_overtime.sunday_daily_overtime_rule || this.daily_overtime.sunday_daily_overtime_rule === ''
            || !this.daily_overtime.saturday_daily_overtime_rule || this.daily_overtime.saturday_daily_overtime_rule === ''
        ) {
          this.dataIncomplete();
          return;
        }

        //正班工时是否填写开始时间
        /*if (this.checkStr(this.daily_overtime.working_day_daily_overtime_rule,this.daily_overtime.working_day_daily_overtime_start)) {
          return;
        }
        if (this.checkStr(this.daily_overtime.sunday_daily_overtime_rule,this.daily_overtime.sunday_daily_overtime_start)) {
          return;
        }

        if (this.checkStr(this.daily_overtime.saturday_daily_overtime_rule, this.daily_overtime.saturday_daily_overtime_start)) {
          console.log(this.daily_overtime.saturday_daily_overtime_start)
          return;
        }*/
      }
      
      if (this.weekday_overtime.is_weekend_overtime){
        if (!this.weekday_overtime.working_day_weekday_overtime_rule || this.attendance_day === ''
            || !this.weekday_overtime.sunday_weekday_overtime_rule || this.weekday_overtime.sunday_weekday_overtime_rule === ''
            || !this.weekday_overtime.saturday_weekday_overtime_rule || this.weekday_overtime.saturday_weekday_overtime_rule === ''
        ) {
          this.dataIncomplete();
          return;
        }

        //检查开始时间是否填写
        /*if (this.checkStr(this.weekday_overtime.working_day_weekday_overtime_rule,this.weekday_overtime.working_day_weekday_overtime_start)) {
          return;
        }
        if (this.checkStr(this.weekday_overtime.sunday_weekday_overtime_rule,this.weekday_overtime.sunday_weekday_overtime_start)) {
          return;
        }

        if (this.checkStr(this.weekday_overtime.saturday_weekday_overtime_rule, this.weekday_overtime.saturday_weekday_overtime_start)) {
          return;
        }*/
      }
      if (this.awards.salary_clean_cloth){
        if (!this.awards.subsidy_department || this.awards.subsidy_department.length === 0){
          this.$message({
            message: "请选择无尘服补贴的部门",
            type: "error",
          });
          return
        }
      }


      let params = {
        id: this.parentData.id,
        salary_type: this.salary_type,
        salary_work_year: this.salary_work_year,
        work_day: this.work_day,
        holiday_day: this.holiday_day,
        description:this.description,
        days: this.days,
        paid_leave: this.paid_leave,
        attendance_day: this.attendance_day,
        daily_overtime: this.daily_overtime,
        weekday_overtime: this.weekday_overtime,
        awards: this.awards,
        deductions: this.deductions
      }
      await this.$http("salaryTypeSetService.saveSalaryType", params);
      this.$message.success("保存成功！");
      this.$fn.closeWindow();
      this.$fn.search();
    },
    /*checkStr(rule, start) {
      if (rule === 'regular_overtime' && (!start || start==='')) {
        this.dataIncomplete();
        return true
      }
      return false
    },*/

    async getData() {
      let params = {
        id: this.parentData.id
      }
      if (params.id !== undefined) {
        let data = await this.$http("salaryTypeSetService.getSalaryTypeData", params);
        this.salary_type = data.salary_type;
        this.description = data.description;
        this.salary_work_year = data.salary_work_year;
        this.work_day = data.work_day;
        this.holiday_day = data.holiday_day;
        if (data.days) {
          this.days = JSON.parse(data.days);
        }
        this.paid_leave = data.paid_leave;

        this.attendance_day = data.attendance_day;
        this.daily_overtime.is_daily_overtime = data.is_daily_overtime;
        this.daily_overtime.working_day_daily_overtime_rule = data.working_day_daily_overtime_rule;
        this.daily_overtime.saturday_daily_overtime_rule = data.saturday_daily_overtime_rule;
        this.daily_overtime.sunday_daily_overtime_rule = data.sunday_daily_overtime_rule;

        this.daily_overtime.working_day_daily_overtime_start = data.working_day_daily_overtime_start;
        this.daily_overtime.saturday_daily_overtime_start = data.saturday_daily_overtime_start;
        this.daily_overtime.sunday_daily_overtime_start = data.sunday_daily_overtime_start;


        this.weekday_overtime.is_weekend_overtime = data.is_weekend_overtime;
        this.weekday_overtime.working_day_weekday_overtime_rule = data.working_day_weekday_overtime_rule;
        this.weekday_overtime.saturday_weekday_overtime_rule = data.saturday_weekday_overtime_rule;
        this.weekday_overtime.sunday_weekday_overtime_rule = data.sunday_weekday_overtime_rule;

        this.weekday_overtime.working_day_weekday_overtime_start = data.working_day_weekday_overtime_start;
        this.weekday_overtime.saturday_weekday_overtime_start = data.saturday_weekday_overtime_start;
        this.weekday_overtime.sunday_weekday_overtime_start = data.sunday_weekday_overtime_start;


        this.awards.salary_on_job = data.salary_on_job;
        this.awards.salary_full_attendance = data.salary_full_attendance;
        this.awards.salary_car = data.salary_car;
        this.awards.salary_house = data.salary_house;
        this.awards.salary_clean_cloth = data.salary_clean_cloth;
        this.awards.salary_post = data.salary_post;
        this.awards.salary_performance = data.salary_performance;
        this.awards.salary_temperature = data.salary_temperature;
        /*if(data.subsidy_department){
          for(let item of data.subsidy_department){
            this.awards.subsidy_department.push(item)
          }
        }*/
        this.awards.subsidy_department = data.subsidy_department


        this.deductions.water_electricity_deduction = data.water_electricity_deduction;
        this.deductions.difference_deduction = data.difference_deduction;
        this.deductions.deduction = data.deduction;

        this.subsidy_department_options = data.subsidy_department_options


      }
    },
    dataIncomplete() {
      this.$message({
        message: "请将平时加班时长计算规则填写完整",
        type: "error",
      });
    },
    //获取部门列表
    async getDepartmentList() {
      this.departmentList = await this.$http('sysUserDepartmentService.getDepartmentData');
    },

  },
  created() {
    this.getData();
    this.getDepartmentList();
  },

}
</script>

<style scoped lang="less">
.box {
  border: 1px solid black;
  border-radius: 5px;
  border-color: #cccccc;
  margin: 10px;
  padding-top: 10px;
}

.checkbox-group {
  display: flex;
  flex-direction: column;
}

.custom-label {
  font-size: 16px;
  font-weight: bold;
}


</style>